import React, { useContext } from 'react'
import Login from '../../components/login/login'
import { DataContext } from '../../app/data-context'
import AccommodationView from './accomodation-view'

const Accommodation: React.FC = () => {
  const { context } = useContext(DataContext);

  return !context?.group ? <Login /> : <AccommodationView />
}

export default Accommodation
